import { Box, Typography } from '@mui/material';
import React from 'react';

const bulletListSx = {
  '& > li': { listStyleType: 'disc', pl: 2 },
  width: '200px',
  textAlign: 'left',
} as const;

export function ReportAccessLossBulletList() {
  return (
    <Box component="ul" sx={bulletListSx}>
      <li>API access</li>
      <li>Dashboard access</li>
      <li>Scheduled reports</li>
    </Box>
  );
}

type ReportAccessLossWarningProps = {
  intro: React.ReactNode;
  lossDescription: React.ReactNode;
  footer?: React.ReactNode;
};

export function ReportAccessLossWarning({
  intro,
  lossDescription,
  footer,
}: ReportAccessLossWarningProps) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography component="div">{intro}</Typography>
      <Typography
        variant="body2"
        color="error.main"
        sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        {lossDescription}
        <ReportAccessLossBulletList />
      </Typography>
      {footer ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {footer}
        </Typography>
      ) : null}
    </Box>
  );
}
